import { Box, Typography, useTheme } from "@material-ui/core";
import React from "react";
import Loader from "react-loader-spinner";
import EmptyComponent from "../empty-component";

interface IProps {
  loading?: boolean;
  loadingHeight?: number | string;
  loadingText?: string;
  empty?: boolean;
  emptyText?: string;
}

const DataLoader: React.FC<IProps> = ({
  children,
  loading,
  loadingHeight,
  loadingText,
  empty,
  emptyText
}) => {
  const theme = useTheme();
  if (loading) {
    return (
      <Box
        display="flex"
        flexGrow={1}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height={loadingHeight}
      >
        <Loader type="Bars" color={theme.palette.primary.main} />
        {Boolean(loadingText) && (
          <Box py={2}>
            <Typography color="primary">{loadingText}</Typography>
          </Box>
        )}
      </Box>
    );
  }
  if(empty){
    return (
      <EmptyComponent content={emptyText}/>
    )
  }
  return (
    <React.Fragment>
      {children}
    </React.Fragment>
  );
};

export default DataLoader;
